import setPromiseState from '../../utils/promiseState';

export default{
  orders: [],
  order: null,
  promise: {
    getUserOrders: setPromiseState(),
    getUserOrder: setPromiseState(),
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/InitState.js